export type VolumePage = {
  src: string
  alt: string
}

/** Páginas reales del Volumen 5, en el orden del carrusel. */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5BHcjQC2vLkUwQESMSwsjD/carrusel-01-p1.png',
    alt: 'Volume 5 cover: Dreams, Fantasy & Creative Media',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pSMXwPSxfrVKxD9N4AeDfZ/carrusel-02-p6.png',
    alt: 'The Dream Ownership Sequence framework',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3utRRTwfD9H432636uUxye/carrusel-03-p18.png',
    alt: 'Experiment card EC-90 Becoming a Plant',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mT4NoD4BXJps4nP7zgHm1h/carrusel-04-p21.png',
    alt: 'Experiment card EC-93 The Doorway',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/u54GKUZ3JaWPJ4T1dk3ikw/carrusel-05-p31.png',
    alt: 'Experiment card EC-98 Self as a Landscape',
  },
]
